import * as React from 'react';
import * as moment from 'moment';
import { IMainstreetEvent } from './classes';


interface ICalendarPaginationProps {
    showAllMonths: boolean;
    hasMoreEvents: boolean;
    previousEventsClick: () => void;
    previousMonthClick: () => void;
    nextEventsClick: () => void;
    nextMonthClick: () => void;
    startDate: moment.Moment;
    events: Array<IMainstreetEvent>;
    offset: number;
    className: string;
}

class CalendarPagination extends React.Component<ICalendarPaginationProps, any>{
    render() {
        const {
            showAllMonths,
            hasMoreEvents,
            startDate,
            offset,
            className
        } = this.props;

        return (
            <div className={className}>
                <button type="button" className="icon-prev-month"
                    onClick={this.onPrevClick.bind(this)}
                    disabled={showAllMonths ? (offset == 0) :
                        (startDate.month() == moment().month() && startDate.year() == moment().year())}>
                    <svg
                        className={"svg-icon " +
                            (showAllMonths ? offset == 0 ? "icon-disabled" : ""
                                : ((startDate.month() == moment().month() && startDate.year() == moment().year()) ? "icon-disabled" : ""))}
                        aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
                    </svg>
                    <span className="text">
                        <span className="visually-hidden">Prev month</span>
                    </span>
                </button>
                <button type="button" className="icon-next-month"
                    onClick={this.onNextClick.bind(this)}
                    disabled={showAllMonths ? (hasMoreEvents ? false : true) :
                        false}>
                    <svg
                        className={"svg-icon " + (showAllMonths ? (hasMoreEvents ? "" : "icon-disabled") :
                            "")}
                        aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-chevron" />
                    </svg>
                    <span className="text">
                        <span className="visually-hidden">Next month</span>
                    </span>
                </button>
            </div>
        );
    }

    onPrevClick() {
        const { showAllMonths, previousEventsClick, previousMonthClick } = this.props;
        showAllMonths ? previousEventsClick() : previousMonthClick();
        this.scrollToTop();
    }

    onNextClick() {
        const { showAllMonths, nextEventsClick, nextMonthClick } = this.props;
        showAllMonths ? nextEventsClick() : nextMonthClick();
        this.scrollToTop();
    }

    scrollToTop() {
        const headerHeight = this.getElementHeightByClass("secondary-header");
        window.scrollTo(0, headerHeight);
    }

    getElementHeightByClass(className: string): number {
        var elts = document.getElementsByClassName(className);
        if (elts.length == 0) return 0;
        return (elts[0] as HTMLElement).offsetHeight;
    }
}



export default CalendarPagination;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar-pagination.tsx